export default __webpack_public_path__ + "static/liuliu-bitmoji-f4c388e337acc2d6f47c9c89274ecd72.png";